import { matchTrackKind, selectableOptions, type Track } from '@anytracker/core'

/**
 * A short badge describing what a track measures.
 *
 * `matchTrackKind` rather than a `switch`, so a fourth value type added to core
 * becomes a compile error here rather than a track quietly rendering with a
 * blank badge.
 */
export function kindLabel(track: Track): string {
  return matchTrackKind(track.kind, {
    numeric: (kind) => `${String(kind.min)}–${String(kind.max)}`,
    boolean: () => 'Yes / no',
    marker: () => 'Marker',
    multi: () => 'Multi-select',
    enum: (kind) => {
      const count = selectableOptions(kind).length
      return `${String(count)} ${kind.ordered ? 'ranked' : 'options'}`
    },
  })
}
